import { parseApiFieldErrors } from '../utils/apiValidationErrors'
import { toUserFacingApiError } from '../utils/userFacingError'

export type ApiClientError = Error & {
  code?: string
  status?: number
  fieldErrors?: Record<string, string>
}

export function throwApiError(err: unknown, fallback: string): never {
  const next = toUserFacingApiError(err, fallback) as ApiClientError
  next.fieldErrors = parseApiFieldErrors(err, next.message)
  throw next
}
